import {customApi} from "./customSdpApiService";


export const getCampaignStatistics = async (data)=>{
  try {
    const response = await customApi.post('/get-campaign-statistics', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const getCampaignStatisticsDetails = async (data)=>{
  try {
    const response = await customApi.post('/get-campaign-statistics-details', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}
